const systemUserRoles = {
  PRICING_REQUESTER: 'pricing-requester'
};

const sideBarItemTitles = {
  DASHBOARD: 'dashboard',
  ANALYTICS_AND_REPORTS: 'analytics / reports',
  INVENTORY: 'inventory'
};

const ATTEMPT_LIMITED =
  'LimitExceededException: Attempt limit exceeded, please try after some time.';

const PASSWORD_WRONG =
  'NotAuthorizedException: Incorrect username or password.';

const FIELD_VALIDATION_MESSAGES = {
  BRAND_NAME_MANDATORY: 'Brand name required',
  TOO_SHOTR: 'Too Short!',
  TOO_LONG: 'Too Long!',
  VALID_LOCATION_NAME: 'Please enter valid location name',
  LOCATION_NAME_MANDATORY: 'Location name required',
  VALID_ADDRESS: 'Please enter valid address',
  ADDRESS_MANDATORY: 'Address required',
  COMPANT_NAME_MANDATORY: 'Company name required',
  DESCRIPTION_MANDATORY: 'Description required',
  CREATE_BRAND_FAILED: 'Create Brand Failed',
  CREATE_BRAND_SUCCESS: 'Created Branch successfully',
  UPDATE_BRAND_SUCCESS: 'Update Branch successfully',
  UNABLE_TO_UPDATE_BRANCH: 'Unable to update Branch'
};
const dataFeedSource = {
  ECLIPSE: 'Eclipse',
  VIRTUAL_YARD: 'Virtual Yard'
};

const allowedRoles = {
  SYSTEM_ADMIN: 'system-admin',
  COMPANY_ADMIN: 'company-admin',
  BRAND_ADMIN: 'brand-admin',
  BRANCH_ADMIN: 'branch-admin',
  USER_ADMIN: 'user'
};

const envLocations = {
  ENV_ESSENDONID: 2027,
  ENV_BOXHILL: 2023
};

const envPriceInformation = {
  ENV_PRICE_LIMIT: 40000,
  ENV_BRAND_UPPER_LIMIT: 2450,
  ENV_BRAND_LOWER_LIMIT: 1450,
  ENV_COMMON_UPPER_LIMIT: 1695,
  ENV_COMMON_LOWER_LIMIT: 995
};

export {
  systemUserRoles,
  sideBarItemTitles,
  ATTEMPT_LIMITED,
  PASSWORD_WRONG,
  FIELD_VALIDATION_MESSAGES,
  dataFeedSource,
  allowedRoles,
  envLocations,
  envPriceInformation
};
